export class BaseFilter {
	constructor() {
		this.type = "Filter";
	}
}